import React from 'react'
import './App.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './Home'

function App() {
  return (
    <div className='app'>
      <Router>
        <Switch>
          <Route path='/'>
            <Home />
          </Route>
          <Route path='/search'>
            <h1>hhhhhhh</h1>
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

export default App
